module.exports = __webpack_public_path__ + "static/media/serumFacial.e42a6fcd.png";